import { Provider } from '@angular/core';
import {
    SEALED_TRADING_QUERY_TOKEN,
    SEALED_TRADING_COMMAND_TOKEN,
    SEALED_TRADING_EVENTS_TOKEN,
    SealedTradingEventsPort,
    SealedTradingCommandPort,
    SealedTradingQueryPort,
} from '@tradgine/sealed-auction-trade';
import { SealedTradingQueryAdapter } from './http/sealed-trading-query.adapter';
import { SealedTradingEventsAdapter } from './web-sockets/sealed-trading-events.adapter';
import { SealedTradingCommandAdapter } from './http/sealed-trading-command.adapter';

export function provideSealedAuctionTrade(): Provider[] {
    return [
        {
            provide: SEALED_TRADING_QUERY_TOKEN,
            useFactory: (): SealedTradingQueryPort => new SealedTradingQueryAdapter(),
        },
        {
            provide: SEALED_TRADING_COMMAND_TOKEN,
            useFactory: (): SealedTradingCommandPort => new SealedTradingCommandAdapter(),
        },
        {
            provide: SEALED_TRADING_EVENTS_TOKEN,
            useFactory: (): SealedTradingEventsPort => new SealedTradingEventsAdapter(),
        },
    ];
}

